import { noop } from "neetocist";
import { isNotNil } from "ramda";
import { useTranslation } from "react-i18next";

import MoreDropdown from "components/MoreDropdown";

const Dropdown = ({
  customDropdown,
  handleManage = noop,
  hideDisconnect = false,
  onDisconnect = noop,
}) => {
  const { t } = useTranslation();

  if (isNotNil(customDropdown)) {
    return <div onClick={e => e.stopPropagation()}>{customDropdown}</div>;
  }

  const isManageable = isNotNil(handleManage);

  if (!isManageable && hideDisconnect) {
    return null;
  }

  return (
    <div onClick={e => e.stopPropagation()}>
      <MoreDropdown
        menuItems={[
          {
            isVisible: isManageable,
            onClick: handleManage,
            label: t("neetoMolecules.integrationCard.manage"),
            key: "integration-card-manage-integration",
          },
          {
            isVisible: !hideDisconnect,
            onClick: onDisconnect,
            label: t("neetoMolecules.integrationCard.disconnect"),
            key: "integration-card-manage-disconnection",
          },
        ]}
      />
    </div>
  );
};

export default Dropdown;
